import { Link } from 'react-router-dom';
import { ExternalLink } from './icons';

interface Props {
  to: string;
  onClick?: () => void;
  /** Trailing text shown on the right side (e.g. "4 数据集 · 8 字段") */
  trailing?: string;
  /** Layout variant: "footer" sits inside a dropdown (top border only); "standalone" is its own box;
   *  "inline" is a compact borderless right-aligned link (minimal footprint). */
  variant?: 'footer' | 'standalone' | 'inline';
}

export function AdvancedSearchHint({ to, onClick, trailing, variant = 'standalone' }: Props) {
  if (variant === 'inline') {
    return (
      <Link
        to={to}
        target="_blank"
        rel="noreferrer"
        onClick={onClick}
        onMouseDown={(e) => e.preventDefault()}
        className="inline-flex items-center gap-1 self-end text-[11px] text-fg-subtle transition-colors hover:text-navy"
      >
        <ExternalLink className="h-3 w-3 text-navy" />
        <span>
          进入更加完善的
          <span className="ml-0.5 font-medium text-navy underline underline-offset-2">
            高级搜索
          </span>
        </span>
      </Link>
    );
  }
  const containerCls =
    variant === 'footer'
      ? 'border-t border-line-subtle bg-canvas'
      : 'border border-line bg-canvas';
  return (
    <Link
      to={to}
      target="_blank"
      rel="noreferrer"
      onClick={onClick}
      onMouseDown={(e) => e.preventDefault()}
      className={`flex items-center justify-between gap-3 px-3 py-2 text-[12px] text-fg-muted transition-colors hover:bg-surface-muted ${containerCls}`}
    >
      <span className="inline-flex items-center gap-1.5">
        <ExternalLink className="h-3.5 w-3.5 text-navy" />
        <span>
          进入更加完善的
          <span className="ml-1 font-medium text-navy underline underline-offset-2">
            高级搜索
          </span>
        </span>
      </span>
      {trailing ? <span className="text-[11px] text-fg-subtle">{trailing}</span> : null}
    </Link>
  );
}
